module.exports = __webpack_public_path__ + "static/neh.1ca01006.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/basic/assets/neh.svg
// module id = 984
// module chunks = 220250618448524